import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// Import translation resources
import commonDe from '@/locales/de/common.json';
import commonEn from '@/locales/en/common.json';
import commonFr from '@/locales/fr/common.json';
import commonIt from '@/locales/it/common.json';

// Define the resources
const resources = {
  en: {
    common: commonEn,
  },
  fr: {
    common: commonFr,
  },
  de: {
    common: commonDe,
  },
  it: {
    common: commonIt,
  },
} as const;

// Configuration
const i18nConfig = {
  debug: process.env.NODE_ENV === 'development',
  resources,
  fallbackLng: 'en',
  defaultNS: 'common',

  // Language detection options
  detection: {
    order: ['localStorage', 'navigator', 'htmlTag'],
    lookupLocalStorage: 'i18nextLng',
    caches: ['localStorage'],
  },

  // Interpolation options
  interpolation: {
    escapeValue: false, // React already escapes values
  },

  // Pluralization options
  pluralSeparator: '_',
  contextSeparator: '_',

  // React specific options
  react: {
    useSuspense: true,
  },

  // Backend options (for future dynamic loading)
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
  },
};

// Initialize i18n
i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init(i18nConfig);

export default i18n;
export { resources };
